// extracted by mini-css-extract-plugin
module.exports = {"root":"_1yia9","item":"_3ONA0","itemContent":"_3CwCR","itemLabel":"dFkrv","textOverflowed":"wzynx"};